"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgMugFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M14 8c1.333 0 2 .667 2 2v1c2.667 0 4 1.333 4 3.999v1C20 18.667 18.667 20 16 20c0 1.333-.666 2-1.999 2H5c-1.333 0-2-.667-2-2V10c0-1.333.667-2 2-2h9zm2 5v5c1.273 0 1.938-.607 1.996-1.822L18 16v-.997C18 13.668 17.333 13 16 13zM7.005 2C7.668 2 8 2.333 8 3v3c0 .667-.334 1-1 1-.666 0-1-.333-1-1V3c.006-.667.341-1 1.005-1zM11 4c.666 0 1 .333 1 1v1c0 .667-.332 1-.996 1-.663 0-.998-.333-1.004-1V5c0-.667.334-1 1-1z' }))); };
exports.default = SvgMugFilled;
//# sourceMappingURL=MugFilled.js.map